import React from 'react'
import { Stack, Typography } from '@mui/material'
import ModeChip from './ModeChip'

type Props = {
    title: React.ReactNode
    live: boolean
}

export default function PreviewHeader({ title, live }: Props) {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
            <Typography variant="subtitle2" fontWeight={700} sx={{ lineHeight: 1.35, minWidth: 0 }}>
                {title}
            </Typography>
            <ModeChip live={live} />
        </Stack>
    )
}
